export interface TranslationsScopeParams {
  // The GlobalAudience feature flag. With it off no question can be made
  // global, so there is nothing to propagate and the master scope is kept —
  // this is what leaves flag-off accounts on exactly the previous behaviour.
  globalAudienceEnabled: boolean
  /** The oldest survey, i.e. the shared questionnaire's scope. */
  masterSurveyId: string | undefined
  /** The market flagged isBase, undefined when no market is. */
  baseSurveyId: string | undefined
  /** Whether the base-market lookup is still resolving. */
  baseMarketLoading: boolean
}

/**
 * The survey the project-level Translations editor reads and writes through.
 *
 * Audience translations only propagate when the write targets the market flagged
 * isBase (BaseMarketPolicy, cin-questionnaire) — not the master in general, since
 * making a question global sets the ACTING market as base.
 *
 * Undefined while the base is unknown, so a save cannot land on a scope about to
 * change. Falling back to the master once resolved is safe: no base means no
 * global question exists.
 */
export const resolveTranslationsSurveyId = ({
  globalAudienceEnabled,
  masterSurveyId,
  baseSurveyId,
  baseMarketLoading
}: TranslationsScopeParams): string | undefined => {
  if (!globalAudienceEnabled) {
    return masterSurveyId
  }
  if (baseMarketLoading) {
    return undefined
  }
  return baseSurveyId ?? masterSurveyId
}
